export const siteText = {
  firstWord: 'Hair ',
  lastWord: 'MakeUp ',
};
